import { axios } from "../core/axios.interceptor";

export async function getRemainingBalance(feature){
    const response = await axios.get(`license/features/${feature}/balance`);
    return response;
}

